import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa'; // Import the left arrow icon

function CategoriesTab() {
  const tabClass =
    'px-6 py-2 text-base font-medium border-b-2 border-transparent hover:border-black transition-all ';
  const activeClass = ' text-white bg-black';

  return (
    <div className="mb-4">
      <NavLink
        to="/dashboard/mdm/menu-items-managment"
        className="flex items-center text-gray-400 hover:text-black mb-4"
      >
        <FaArrowLeft className="mr-3 text-md" /> {/* Left arrow icon */}
        <span className="text-lg">Back to Menu Items Managment</span>
      </NavLink>

      {/* Tabs container */}
      <div className="flex  border-b">
        <NavLink
          to="/dashboard/mdm/menu-items-managment/add-category"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-white'}`
          }
        >
          Add Category
        </NavLink>
        <NavLink
          to="/dashboard/mdm/menu-items-managment/add-subcategory"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-white'}`
          }
        >
          Add Sub-Category
        </NavLink>
      </div>
    </div>
  );
}

export default CategoriesTab;
